import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  BoxContainer,
  BoxImage,
  CardContainer,
  CloseButton,
  CloseIcon,
} from "./styles";

function JobEventCard() {
  const isMobile = useMediaQuery("(max-width: 640px)");
  const isTablet = useMediaQuery("(max-width: 1280px)");

  const [showCard, setShowCard] = useState(true);
  const dispatch = useDispatch();

  return (
    <CardContainer visibility={showCard}>
      <BoxContainer
        position={"relative"}
        alignItems={"flex-start"}
        sx={{ width: "100%" }}
      >
        <BoxImage
          onClick={() => {
            window.open(
              `https://my.hiredly.com/jobs/jobs-malaysia-hiredly-job-the-awesome-career-fair-coffee-party-edition?utm_medium=email&utm_source=clevertap&utm_campaign=tacf7`
            );
          }}
          src={
            isMobile
              ? "https://assets.wobbjobs.com/images/hiredly/coffee-party-mobile.png"
              : isTablet
              ? "https://assets.wobbjobs.com/images/hiredly/coffee-party-tablet.png"
              : "https://assets.wobbjobs.com/images/hiredly/coffee-party-web.png"
          }
        />
      </BoxContainer>

      <CloseButton
        onClick={() => {
          setShowCard(false);
        }}
      >
        <CloseIcon />
      </CloseButton>
    </CardContainer>
  );
}

export default JobEventCard;
